












































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import Tools from '../../../../../lib/tools';
import QuickTable from "../../../../../components/table/table.vue";
@Component({
	name:'laborDefensePurchase',
	components: {
		QuickTable
	}
})
export default class LaborDefensePurchase extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		organizations: [],			// 部门数据
		personnels: [],
		formData: {
			purchaseDepId: '',
			articleName: '',
			articleProductDep: '',
			licenseKey: '',
			purchaseDt: '',
			purchaseCount: null,
			articleLiveTime: '',
			purchaseLeaderId: '',
			inspectionUserId: '',
			remark: ''
		},
		validate: {
			articleName: [
				{ required: true, message: '请填写防护用品名称', trigger: 'blur' }
			],
			articleProductDep: [
				{ required: true, message: '防护用品生产（经营）单位', trigger: 'blur' }
			],
			purchaseDt: [
				{ required: true, type: 'date', message: '请选择购进日期', trigger: 'blur' }
			],
			purchaseCount: [
				{ required: true, type: 'number', message: '请填写购进数量', trigger: 'blur' }
			],
			purchaseDepId: [
				{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }
			],
			purchaseLeaderId: [
				{ required: true, type: 'number', message: '请选择采购负责人', trigger: 'change' }
			],
			inspectionUserId: [
				{ required: true, type: 'number', message: '请选择验货人', trigger: 'change' }
			]
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '部门',
				key: 'purchaseDep',
				render: (h:any, params:any) => {
					return h('span', params.row.purchaseDep ? params.row.purchaseDep.displayName : '');
				}
			},
			{
				title: '防护用品名称',
				key: 'articleName'
			},
			{
				title: '防护用品生产（经营）单位',
				key: 'articleProductDep'
			},
			{
				title: '许可证号',
				key: 'licenseKey'
			},
			{
				title: '购进日期',
				key: 'purchaseDt',
				width: 128,
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.purchaseDt, 'yyyy年MM月dd日'));
				}
			},
			{
				title: '购进数量',
				key: 'purchaseCount'
			},
			{
				title: '防护用品使用期限',
				key: 'articleLiveTime'
			},
			{
				title: '采购负责人',
				key: 'purchaseLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.purchaseLeader ? params.row.purchaseLeader.name : '');
				}
			},
			{
				title: '验货人',
				key: 'inspectionUser',
				render: (h:any, params:any) => {
					return h('span', params.row.inspectionUser ? params.row.inspectionUser.name : '');
				}
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personnels = this.$store.state.project.allPersons;
    	})
    }
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k == 'purchaseDt') {
						params[k] = Tools.formatDate(datas[k]);
					}else{
						params[k] = datas[k];
					}
				}
            	this.initData.formLoading = true;
            	await Ajax.post('/api/services/app/LaborDefense/CreatePurchaseAsync', params).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	(this as any).$refs.table.GetData();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    mounted() {
    	this.init();
    }
}
